import { useAppSelector } from '../../stores/redux.store';
import type { RootState } from '../../stores/redux.store';

const selectMicrobranding = (state: RootState) => state.microbranding;

export const useMicrobranding = () => {
  const microbranding = useAppSelector(selectMicrobranding);

  return {
    oidcContext: microbranding.oidcContext,
    isEmbedded: Boolean(microbranding.isEmbedded),
    isMobileApp: microbranding.isMobileApp,
    isAnyMobile: microbranding.isAnyMobile,
    screenSize: microbranding.screenSize,
  };
};
